import { useEffect, useState } from "react";
import { PostRequest } from "../hooks/ApiHandler";
import { GetRequest } from './../hooks/ApiHandler';
import { baseURL, imageURL } from "../constants/constant";
import { toast } from "sonner";
import axios from "axios";


export const getValueOrDash = (value) => {
  return value && value.toString().trim() !== "" ? value : "-";
};

export const getMobileNumberByType = (phoneStr, type = "Mobile") => {
  try {
    if (phoneStr && typeof phoneStr === "string") {
      const phoneArray = JSON.parse(phoneStr);
      if (Array.isArray(phoneArray) && phoneArray.length > 0) {
        // Find phone by type or return first one
        const phoneObj = phoneArray.find(
          (phone) => phone.phone_type === type,
        );
        if (phoneObj) {
          return `${phoneObj.country_code} ${maskContactNumber(phoneObj.phone)}`;
        }
      }
    }
    return "-";
  } catch (error) {
    return "-";
  }
};

// Masking contact number 
export const maskContactNumber = (value = "") => {
  const customer = JSON.parse(localStorage.getItem("customer"));
  const userType = customer?.customer_details?.user_type;
  const isHashed = customer?.customer_details?.is_hashed;

  if (userType === "1") {
    return value;
  }

  if (isHashed === "no") {
    return value;
  }

  const digits = String(value).replace(/\D/g, "");
  if (digits.length <= 2) return digits;
  return "*".repeat(digits.length - 2) + digits.slice(-2);
};

// date format converter
export const formatDate = (datetime) => {
  if (!datetime) return "";
  const date = new Date(datetime);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

// Format time from 24-hour to 12-hour format
// export const formatTime = (timeStr) => {
//   if (!timeStr) return ""
//   const [hour, minute] = timeStr.split(":").map(Number)
//   const date = new Date(Date.UTC(1970, 0, 1, hour, minute))
//   return new Intl.DateTimeFormat(undefined, {
//     hour: "numeric",
//     minute: "2-digit",
//     hour12: true,
//   }).format(date)
// }

export const formatTime = (timeStr) => {
  if (!timeStr) return ""
  let [hour, minute] = timeStr.split(":")
  hour = Number.parseInt(hour)
  const ampm = hour >= 12 ? "PM" : "AM"
  hour = hour % 12 || 12
  return `${hour}:${minute} ${ampm}`
}

export const add5HoursTo12HrTime = (timeStr) => {
  if (!timeStr) return "N/A";

  const [time, modifier] = timeStr.split(" ");
  let [hours, minutes] = time.split(":").map(Number);

  if (modifier === "PM" && hours !== 12) hours += 12;
  if (modifier === "AM" && hours === 12) hours = 0;

  hours += 5;
  minutes += 30;
  hours = hours % 24;
  const newModifier = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours === 0 ? 12 : hours;

  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")} ${newModifier}`;
};



export const PaginationButtons = (totalCount, limit) => {
  const totalButtons = Math.ceil(totalCount / limit)
  let mapButtons = []
  for (let i = 0; i < totalButtons; i++) {
    mapButtons.push(
      i + 1
    )
  }
  return mapButtons.length > 1 ? mapButtons : [];
}

export function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value)
    }, delay)

    return () => {
      clearTimeout(handler)
    }
  }, [value, delay])

  return debouncedValue
}

export async function checkDuplicate({
  col,
  customer_id,
  validating_val,
  contact_id,
  checkFor,
  existing_val = ""
}) {
  if (!validating_val || validating_val === existing_val) {
    return false // No value to check
  }

  try {
    const response = await PostRequest(`${checkFor === "register" ? "/auth/register" : "/contacts"}/checkDuplicate/`, { col, customer_id, validating_val, contact_id })

    if (response.status === "fail") {
      return
    }
    if (response.status === "unverified") {
      return response
    }
    return response
  } catch (error) {
    console.error("Error checking duplicate:", error)
    return false
  }
}

// export async function checkDuplicate({
//   col,
//   customer_id,
//   validating_val,
//   contact_id,
//   checkFor,
//   existing_val = ""
// }) {
//   if (!validating_val || validating_val === existing_val) {
//     return false // No value to check
//   }

//   try {
//     const response = await PostRequest(`${checkFor === "register" ? "/auth" : "/contacts"}/checkDuplicate/`, { col, customer_id, validating_val, contact_id })

//     if (response.status === "fail") {
//       return;
//     }
//     return response.data && response.data.length > 0
//   } catch (error) {
//     console.error("Error checking duplicate:", error)
//     return false
//   }
// }

// date timezone function
export const convertDateToTimezone = (date, targetTimeZone) => {
  // Ensure the input is a valid Date object.
  // If a string is passed, attempt to convert it to a Date object.
  const d = (typeof date === 'string' ? new Date(date) : date);

  if (!(d instanceof Date) || isNaN(d.getTime())) {
    console.error("Invalid date provided.");
    return null;
  }

  // Use toLocaleString to get a string representation in the target timezone.
  // 'en-US' is used as a locale for consistent formatting,
  // but you can choose any valid locale.

  // Add 5 hours 30 minutes (19800000 milliseconds) to convert IST → GMT
  const gmtTime = new Date(d.getTime() - (5.5 * 60 * 60 * 1000));
  const options = {
    timeZone: targetTimeZone,
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: true // Use 24-hour format for consistency
  };

  const formattedDateString = gmtTime.toLocaleString('en-US', options);

  // Convert the formatted string back into a Date object if needed,
  // although often the string representation is sufficient.
  // Note: Creating a new Date object from the formatted string might
  // still result in a Date object whose internal UTC value is adjusted
  // to reflect the *local* interpretation of that time in the *current*
  // environment's timezone, so be mindful if you need precise UTC values.


  return new Date(gmtTime);
}

// // Example Usage:
// const now = new Date(); // Current date and time in local timezone

// // Convert to New York time
// const newYorkTime = convertDateToTimezone(now, 'America/New_York');


// // Convert to London time
// const londonTime = convertDateToTimezone(now, 'Europe/London');


// // Convert a specific UTC date string to a different timezone
// const utcDateString = "2025-07-23T15:30:00Z"; // UTC time
// const tokyoTime = convertDateToTimezone(utcDateString, 'Asia/Tokyo');



export async function checkCompanyDuplicate({
  customer_id,
  validating_val,
  contact_id,
}) {
  if (!validating_val) {
    return false // No value to check
  }

  try {
    const response = await PostRequest("/company/checkDuplicateCompanyName", { customer_id, validating_val, contact_id })

    if (response.status === "fail") {
      return;
    }
    return response.data && response.data.length > 0
  } catch (error) {
    console.error("Error checking duplicate:", error)
    return false
  }
}

// function to convert number to indian ruppess
export const formatToINR = (amount = 0) => {
  const num = amount ? Number(amount) : 0
  if (typeof num !== 'number') return 'Invalid amount';

  return num.toLocaleString('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 2,
    minimumFractionDigits: 2
  });
};


// function to show today, this month, this year lead in indian format 
export const putCommaInLeadsValue = (amount) => {
  if (amount === "") {
    return 0;
  } else {

    const num = Number(amount)
    if (typeof num !== 'number') return 'Invalid amount';

    return num.toLocaleString('en-IN', {
      // style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0,
    });
  }
};

export function stripHtml(html) {
  const div = document.createElement("div");
  div.innerHTML = html;
  return div.textContent || div.innerText || "";
}


// convert date into alphabetical month name and 2 digit date with comma separated full year
export function formatDateInAlphabeticalMonth(apiDate) {
  const date = new Date(apiDate);
  return new Intl.DateTimeFormat("en-US", {
    month: "short",   // Aug
    day: "2-digit",   // 26
    year: "numeric"   // 2025
  }).format(date);
}

export const customStyles = {
  control: (provided, state) => ({
    ...provided,
    padding: "0.1rem 0.75rem",
    minHeight: "50px",
    boxShadow: "none",
    border: state.isFocused ? "1px solid #2684FF" : "1px solid #ccc",
  }),
  input: (provided) => ({
    ...provided,
    padding: ".3rem 0rem 0.1rem ",
  }),
  placeholder: (provided) => ({
    ...provided,
    margin: "1.2rem 0px 0rem",
    fontSize: "0.9rem",
  }),
  singleValue: (provided) => ({
    ...provided,
    margin: "1.2rem 0px 0rem",
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    paddingTop: "0.1rem",
    paddingBottom: "0.1rem",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: "0.25rem",
  }),
  menuList: (base) => ({
    ...base,
    maxHeight: 200,
    overflowY: 'auto',
    '::-webkit-scrollbar': {
      width: '8px',
    },
    scrollBehavior: 'smooth',
    '::-webkit-scrollbar-track': {
      background: '#f1f1f1',
      borderRadius: '4px',
    },
    '::-webkit-scrollbar-thumb': {
      background: '#c9c9c9',
      borderRadius: '4px',
    },
    '::-webkit-scrollbar-thumb:hover': {
      background: '#888888',
    }
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999
  }),
  multiValue: (base) => ({
    ...base,
    marginTop: '21px',
    backgroundColor: '#3b82f6', // blue-500
    color: 'white',
  }),
  multiValueLabel: (base, state) => ({
    ...base,
    color: 'white',
    fontWeight: '500',
  }),
  multiValueRemove: (base, state) => ({
    ...base,
    color: 'white',
    ':hover': {
      backgroundColor: '#ef4444', // red-500 on hover
      color: 'white',
    },
  }),
};


export async function getModuleSeries(customer_id, module_name) {
  try {
    const response = await GetRequest(`common/fetchPrefixSeries/${customer_id}/${module_name}`)
    if (response.status === "fail") {
      return;
    }
    return response.data
  } catch (error) {

  }
}

// function for handling date time passed or not and style the color of date and time
export function isDateTimePassed(due_date, due_time) {
  if (!due_date || !due_time) return false;

  try {
    let time = due_time.trim();

    if (/PM|AM/i.test(time)) {
      // If it already has AM/PM, assume it's 12-hour format
      // But if hours > 12, drop AM/PM because it's broken
      const [hourStr, minute] = time.replace(/(AM|PM)/i, "").trim().split(":");
      const hour = parseInt(hourStr, 10);
      if (hour > 12) {
        time = `${hour}:${minute}`; // remove AM/PM for 24-hour format
      }
    }

    // Build datetime string safely
    const dateTimeString = `${due_date} ${time}`;
    const dueDateTime = new Date(dateTimeString);
    const now = new Date();

    if (isNaN(dueDateTime.getTime())) {
      console.error("Invalid date from response:", due_date, due_time);
      return false;
    }

    return dueDateTime < now;
  } catch (error) {
    console.error("Date parse error:", error);
    return false;
  }
}

export function TextWithLineBreaks(text) {
  return (
    <div>
      {text.split(/\r\n|\n/).map((line, index) => (
        <span key={index}>
          {line}
          <br />
        </span>
      ))}
    </div>
  );
}


export const formatAmountInAlphabets = (num) => {
  if (num >= 10000000) {
    // 1 crore = 10,000,000
    return (num / 10000000).toFixed(1).replace(/\.0$/, '') + ' Cr';
  } else if (num >= 100000) {
    // 1 lakh = 1,00,000
    return (num / 100000).toFixed(1).replace(/\.0$/, '') + ' L';
  } else if (num >= 1000) {
    return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
  } else {
    return num.toString();
  }
}
// handle print function
export const handlePrint = async (endpoint, customerId, moduleId) => {
  const fileUrl = ` ${baseURL}/${endpoint}/${customerId}/${moduleId}`;

  // PDF ko blob me fetch karna
  const res = await fetch(fileUrl, { method: "GET" });
  const blob = await res.blob();
  const pdfUrl = URL.createObjectURL(blob);

  const printWindow = window.open("", "_blank");
  printWindow.document.write(`
    <html>
      <head>
        <title>Print Preview</title>
        <style>
          body, html {
            margin: 0;
            padding: 0;
            height: 100%;
            overflow: hidden;
          }
          iframe {
            width: 100%;
            height: 100%;
            border: none;
          }
          .toolbar {
            position: fixed;
            top: 0;
            left: 0;
            width: 99%;
            background: #f5f5f5;
            border-bottom: 1px solid #ccc;
            padding: 8px;
            display: flex;
            justify-content: flex-end;
            gap: 10px;
            z-index: 9999;
          }
          .toolbar button, .toolbar a {
            background: #1976d2;
            color: white;
            padding: 6px 12px;
            border-radius: 4px;
            border: none;
            cursor: pointer;
            text-decoration: none;
          }
        </style>
      </head>
      <body>
        <div class="toolbar">
          <button onclick="window.print()">Print</button>
          <a href="${pdfUrl}" download>Download</a>
        </div>
        <iframe src="${pdfUrl}" frameborder="0"></iframe>
      </body>
    </html>
  `);
  printWindow.document.close();
};

// function to convert and download the csv file
export const downloadCSV = async (module_name, data) => {
  try {
    if (data) {
      const csvString = data;
      const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });

      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${module_name}${new Date().toISOString().split('T')[0]}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      return true;
    }
    return false
  } catch (error) {
    return false;
  }
};


// function for printing or save as pdf file
export const printPdf = async (url, headers, type) => {
  try {
    const res = await GetRequest(
      // last parameter must be type what to do print or download
      `${url}/${type}`,
      { headers }
    );

    if (res.status === "fail") {
      toast.error(res.message || "Please select a template first");
      return;
    }

    if (res.status === "success" && res.data) {
      const htmlContent = res.data;

      // 🧩 Create hidden iframe (no popup, no visible window)
      const iframe = document.createElement("iframe");
      iframe.style.position = "fixed";
      iframe.style.right = "0";
      iframe.style.bottom = "0";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "none";
      document.body.appendChild(iframe);

      // 🧾 Write HTML into iframe with white background
      iframe.contentDocument.open();
      iframe.contentDocument.write(`
        <html>
          <head>
            <style>
              @page { size: A4; margin: 11mm; background: white; }
              body { background: white !important; margin: 0; }
            </style>
          </head>
          <body>${htmlContent}</body>
        </html>
      `);
      iframe.contentDocument.close();

      // 🕒 Wait a bit to ensure full rendering before saving
      setTimeout(() => {
        iframe.contentWindow.focus();

        // 📄 Use browser print-to-PDF silently (requires user default settings)
        iframe.contentWindow.print();

        // 🧹 Clean up
        setTimeout(() => document.body.removeChild(iframe), 1000);
      }, 500);
    } else {
      toast.error("No quotation data found.");
    }
  } catch (error) {
    toast.error("Something went wrong while downloading the PDF.");
  }
};

// functin to download pdf
export const downloadPdf = async (url, headers, type, module_name) => {
  try {
    const fullUrl = `${url}/${type}`;

    //  Use axios directly instead of GetRequest (important)
    const res = await axios.get(fullUrl, {
      headers,
      responseType: "blob",
      validateStatus: () => true,
    });

    // Try to detect a fail response by checking if it's JSON
    const contentType = res.headers["content-type"];

    if (contentType && contentType.includes("application/json")) {
      // Convert blob (JSON) to text and parse
      const text = await res.data.text?.() ?? await new Response(res.data).text();
      const errorData = JSON.parse(text);

      if (errorData.status === "fail") {
        toast.error(errorData.message || "Failed to download PDF");
        return;
      }
    }

    //  Otherwise, assume it’s a valid PDF binary
    const blob = new Blob([res.data], { type: "application/pdf" });
    const blobUrl = URL.createObjectURL(blob);
    const date = new Date().toLocaleString().split(",")[0].replace(/[/,: ]/g, "_");

    // Trigger download
    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = `${module_name}_${date}.pdf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    // Cleanup
    URL.revokeObjectURL(blobUrl);
  } catch (error) {
    toast.error("Something went wrong while downloading PDF.");
  }
};


export const handleExportData = async (label, module, headers, extras, setLoading) => {
  try {
    setLoading(true)
    const payload = {
      customer_id: extras.customer.customer_details?.customer_id,
      user_login_id: extras.customer.customer_details?.id,
      module_name: module,
      labels: label
    }

    const res = await PostRequest(`/csv/ExportData/`, payload, false, { headers }, extras)
    if (res.success === false) {
      toast.error("Failed To Download CSV data!")
      setLoading(false)
      return
    }

    setLoading(false)
    if (res.data) {
      downloadCSV(module, res.data)
    }
  } catch (error) {
    setLoading(false)
    return
  }
}

// usepermission is a custom hook for allowing the permission with respect to the pipeline shared to the user 
export const usePermissions = (customer, parsedSharedUsers, apiData) => {
  if (apiData === undefined || apiData === null) return { permissionAssigned: null, canEdit_canDownload: false }
  const isOwner = customer.customer_details?.id === apiData?.pipeline_data?.["added_by"]
  const isSoftware_owner = customer.customer_details?.user_type === "1";
  const isShareExist = (parsedSharedUsers !== null && parsedSharedUsers?.length !== 0 && parsedSharedUsers !== false) && parsedSharedUsers?.find(c => c.id === customer.customer_details?.id)
  const permissionAssigned = isShareExist && Object.entries(isShareExist?.permissions?.[0])?.find(([key, value]) => {
    if (value === true) {
      return key
    }
    return
  })?.[0]

  // single state rather defining it everywhere
  const canEdit_canDownload = isOwner || isSoftware_owner || (permissionAssigned === "can_edit" || permissionAssigned === "can_download")
  // i have returned both of 'em cuz i wanna make sure that if its can_download then the download operation is disalbled for that user.
  return { permissionAssigned, canEdit_canDownload };
}

export async function checkDuplicate_edit({
  col,
  customer_id,
  user_id,
  validating_val,
  contact_id,
  checkFor,
  existing_val = ""
}) {
  if (!validating_val || validating_val === existing_val) {
    return false // No value to check
  }

  try {
    const response = await PostRequest(`${checkFor === "register" ? "/auth/register" : "/contacts"}/checkDuplicate_edit/`, { col, validating_val, contact_id, user_id })

    if (response.status === "fail") {
      return
    }
    if (response.status === "unverified") {
      return response
    }
    return response.data && response
  } catch (error) {
    console.error("Error checking duplicate:", error)
    return false
  }
}

export const getColCount = (columns) => {
  let count = 0;

  for (const key in columns) {
    if (columns[key] === true) {
      count++;
    }
  }

  return count;
};

export async function fetchRecentActivity(moduleName, moduleId, headers = {}, extras = {}) {
  try {
    const url = `${baseURL}common/fetchActivity/${moduleName}/${moduleId}`;
    const response = await GetRequest(url, headers, extras);
    return response;
  } catch (error) {
    console.error("Error fetching activity:", error);
    throw error;
  }
}

// to dowload pdf or images from s3bucket
export const handleDownloadFile = async ({ docPath, headers, extras }) => {
  try {
    if (!docPath) {
      toast.error("No document found")
      console.log("docPath", docPath)
      return
    }
    const urlArr = docPath?.split("/")
    const docName = urlArr[urlArr.length - 1]
    const res = await GetRequest(`${baseURL}common/downloadfile/?file=${imageURL}${docPath}`, { headers }, extras)
    if (res.status === "fail" || res.success === false) {
      toast.error(res.message)
      return
    }
    const downloadUrl = res.data
    // Use direct link download to avoid CORS issue
    const link = window.document.createElement('a');
    link.href = downloadUrl;
    link.setAttribute('download', docName);
    window.document.body.appendChild(link);
    link.click();
    window.document.body.removeChild(link);
  } catch (error) {
    toast.error('Internal server error')
    return
  }
}



export const checkTwilioIntegration = async (customer_id, headers, extras) => {
  try {
    const res = await GetRequest(
      `${baseURL}voice/is_CredentialAvailable/${customer_id}`,
      { headers },
      extras,
    );
    return res
  } catch (error) {
    console.log(error);
  }
};
